import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { Segment } from "#app/(unauthorized)/authentication/segment";
import { useJwtSegment } from "#app/(unauthorized)/authentication/useJwt";

const urlMap = {
  FUND: "mutual-funds",
  fund: "mutual-funds",
  ETF: "exchange-traded-funds",
  etf: "exchange-traded-funds",
  STOCK: "stocks",
} as const satisfies Record<string, string>;

export function useStockLinkClick(assetType?: keyof typeof urlMap) {
  const router = useRouter();
  const segment = useJwtSegment();
  return useCallback(
    ({
      detail,
    }: {
      detail: { identifier: string; assetClass: keyof typeof urlMap }[];
    }) => {
      if (detail && detail.length > 0 && detail[0]) {
        const { identifier, assetClass } = detail[0];
        const asset = urlMap[assetType ?? assetClass] || "stocks";
        const url = `/${segment === Segment.NotLoggedIn ? "market-tools" : "investing-tools"}/${asset}/${identifier}`;
        if (window.location.pathname === url) {
          window.location.reload();
          return;
        }
        router.replace(
          `/${segment === Segment.NotLoggedIn ? "market-tools" : "investing-tools"}/${asset}/${identifier}`,
        );
      }
    },
    [router, segment, assetType],
  );
}
